import { Tooltip, Typography } from '@mui/material'

import { DateTime } from 'luxon'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {string} props.createdOn
 * @param {string} props.endTime
 * @param {Object} props.property
 * @param {string} props.property.timezone
 * @param {boolean} [props.mobileView]
 */
export default function EventListCreatedOnCell({
  createdOn,
  endTime,
  property,
  mobileView,
}) {
  const createdLuxon = DateTime.fromISO(createdOn, { zone: property.timezone })
  const endLuxon = endTime
    ? DateTime.fromISO(endTime, { zone: property.timezone })
    : DateTime.now()

  const formattedCreatedOn = createdLuxon.toLocaleString(DateTime.DATETIME_SHORT)
  const endTimeFormat = createdLuxon.hasSame(endLuxon, 'day')
    ? DateTime.TIME_SIMPLE
    : DateTime.DATETIME_MED
  const formattedEndTime = endLuxon.toLocaleString(endTimeFormat)

  return (
    <Tooltip title={`${formattedCreatedOn} - ${formattedEndTime}`} placement="top">
      <Typography variant={mobileView ? 'caption' : 'body2'}>
        {formattedCreatedOn}
      </Typography>
    </Tooltip>
  )
}
